import React, { createContext, ReactNode, useCallback, useEffect, useState } from "react";
import Spinner from "@amzn/awsui-components-react/polaris/spinner";
import { AuthStatus, signIn } from "../../auth/dialogSignin";
import { Auth } from "aws-amplify";
import jwtDecode from "jwt-decode";

export interface AuthState {
  token: string;
  alias: string;
}

interface AliasBlockerProps {
  children: ReactNode;
}

export const AuthContext = createContext<AuthState | undefined>(undefined);

const AuthCheck = (props: AliasBlockerProps) => {
  const [authState, setAuthState] = useState<AuthState>({ token: "", alias: "" });
  const [authStatus, setAuthStatus] = useState<AuthStatus>(AuthStatus.NOT_LOGGED_IN);
  const loadAuthStatusFromSession = useCallback(
    (session) => {
      const jwtToken = session.getIdToken().getJwtToken();
      const data: any = jwtDecode(jwtToken);
      setAuthState({ alias: data.name, token: jwtToken });
    },
    [setAuthState]
  );

  useEffect(() => {
    // signs user in if they are not authenticated on app mount
    Auth.currentSession()
      .then(() => {
        console.log("Found STH Excel Add In session");
        setAuthStatus(AuthStatus.LOGGED_IN_SUCCESS);
      })
      .catch(() => {
        console.log("Beginning STH Excel Add In session");
        signIn(setAuthStatus);
      });
  }, [setAuthStatus]);

  useEffect(() => {
    if (authStatus === AuthStatus.LOGGED_IN_SUCCESS) {
      Auth.currentSession().then(loadAuthStatusFromSession);
    }
  }, [authStatus, loadAuthStatusFromSession]);

  if (authStatus === AuthStatus.LOGGED_IN_SUCCESS.toString()) {
    return <AuthContext.Provider value={authState}>{props.children}</AuthContext.Provider>;
  }

  return <Spinner />;
};

export default AuthCheck;
